<template>
  <div class="animated fadeIn compras-abm">
    <b-row>
      <b-col xl="12">
        <b-form class="form-compra">
          <b-card no-header>
            <div slot="header">{{ devolucion? 'Devolución' : 'Pago' }} de Viaticos</div>
            <!-- <b-form-group
              v-if="!pagoImpuestos"
              label="Proveedor"
              label-for="proveedor"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="proveedor"
                :value="proveedorNombre"
                readonly
                type="text"/>
            </b-form-group> -->

            <app-caja
              label="Caja"
              :label-cols="labelCols"
              :nombre="cajaRegistroNombre"
              :valido="cajaRegistroValida"
              :lista="cajasRegistrosList"
              :msjInvalido="cajaRegistroInvalidaMsj"
              @validate="validate"
              @updated="cajaRegistroActualizada">
            </app-caja>  
          </b-card>

          <b-card>
            <b-row>
              <b-col cols="6">
                <b-form-group
                  label="Pesos"
                  label-for="pesos"
                  :label-cols="labelCols * 2"
                  horizontal>
                  <b-form-input 
                    id="pesos"
                    v-model.trim="$v.pesos.$model" 
                    :state="pesosValido"
                    type="text"
                    @blur.native="validate">
                  </b-form-input>
                  <b-form-invalid-feedback id="pesosFeedback">
                    {{ pesosInvalidoMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>

                <b-form-group
                  label="Transferencias"
                  label-for="transferencias"
                  :label-cols="labelCols * 2"
                  horizontal>
                  <b-input-group>
                    <b-input-group-append 
                        class="filter-search-icons" 
                        @click="agregarTransferencia">
                      <b-input-group-text>
                        <i class="fa fa-plus"></i>
                      </b-input-group-text>
                    </b-input-group-append>
                    <b-form-input 
                      id="transferencias"
                      :value="importeTransferencias | moneda"
                      :readonly="Boolean(true)">
                    </b-form-input>
                  </b-input-group>

                  <b-table 
                      v-if="transferencias.length != 0"
                      hover
                      responsive="sm" 
                      class="pagos-documentos"
                      :busy="tableBusy"
                      :items="transferencias" 
                      :fields="transferenciasFields">

                    <template v-slot:cell(fechaCreditoDebito)="data">
                      {{ data.item.fechaCreditoDebito | fecha }}
                    </template>
                    <template v-slot:cell(importe)="data">
                      {{ data.item.importe | moneda }}
                    </template>
                    <template v-slot:cell(borrar)="data">
                      <i class="fa fa-remove" @click.stop="borrarTransferencia(data.item)"></i>
                    </template>
                  </b-table>
                </b-form-group>
              </b-col>

              <b-col cols="6">
                <b-form-group
                  label="Total Documentos"
                  label-for="totalDocumentos"
                  :label-cols="labelCols * 2"
                  horizontal>
                  <b-form-input 
                    id="totalDocumentos"
                    :value="totalDocumentos | moneda"
                    :readonly="Boolean(true)">
                  </b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card>

          <!-- <b-card>
            <b-form-group
              label="Observaciones"
              label-for="observaciones"
              :label-cols="labelCols"
              horizontal>
              <b-form-textarea
                id="observaciones"
                v-model="$v.observaciones.$model" 
                rows="3"
                max-rows="6"
                :state="observacionesValidas"
                @blur.native="validate">
              </b-form-textarea>
              <b-form-invalid-feedback id="observacionesFeedback">
                {{ observacionesInvalidasMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>
          </b-card> -->
        </b-form>
      </b-col>
    </b-row>

    <b-modal ref="addTransferenciaModal" 
        title="Transferencias Bancarias"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="modalABM">
      <app-transferencia
        :cuentasPesos="true"
        @transferenciaAgregada="transferenciaAgregada"
        @cancel="transferenciaCancelada">
      </app-transferencia>
    </b-modal>

    <app-a-b-m-button
      @save="save"
      @cancel="goBack">
    </app-a-b-m-button>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import ABMButtons from '../shared/abmButtons.vue';
import Caja from '../shared/abmSelect.vue';
import Transferencia from '../bancosmovimientos/Movimiento.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs';
import { decimal, minValue } from 'vuelidate/lib/validators';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'viaticoPago/getField',
  mutationType: 'viaticoPago/updateField',
});

export default {
  name: 'ViaticosPago',
  components: {
    appABMButton: ABMButtons,
    appCaja: Caja,
    appTransferencia: Transferencia,
    appMensaje: Mensaje
  },
  mixins: [ 
    msjModal, 
  ],
  props: {
    devolucion: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      noValidar: true,
      cajaRegistroValida: null,
      cajaRegistroInvalidaMsj: '',
      pesosValido: null,
      pesosInvalidoMsj: '',
      // observacionesValidas: null,
      // observacionesInvalidasMsj: '',

      transferenciasFields: [
        { 
          key: 'fechaCreditoDebito',
          label: 'Fecha'
        },
        { 
          key: 'bancoCuentaNombre',
          label: 'Cuenta'
        },
        { key: 'importe' },
        { 
          key: 'borrar',
          label: '',
          class: 'table-remove-icon' 
        },
      ],

      tableBusy: false,
      labelCols : 2,
      cajasRegistros: [],
      cajasRegistrosList: [],
      noValidar: true,
    }
  },
  computed: {
    ...mapFields([
      // 'observaciones',
      'viaticoId',
      'cajaRegistro',
      'cajaRegistroNombre',
      'pesos',
      'importeTransferencias',
      'transferencias',
    ]),
    totalDocumentos: function() {
      return parseFloat(this.pesos) 
        + parseFloat(this.importeTransferencias);
    },
  },
  created() {
    this.getDatosAdicionales();
    
    let params = {
      viaticoId: this.$route.params.id,
      devolucion: this.devolucion
    }

    this.showSpinner();
    this.$store.dispatch('viaticoPago/inicializar', params)
      .catch( error => this.showErrorMsj (error))
      .finally(() => this.hideSpinner());
  },  
  methods: {
    getDatosAdicionales() {
      let vm = this;
      vm.$store.dispatch('cajasregistros/getCajasRegistrosSelect')
        .then(() => {
          vm.cajasRegistros = this.$store.getters['cajasregistros/cajasRegistrosSelect'];
          vm.cajasRegistrosList = this.$store.getters['cajasregistros/cajasRegistrosSelectList'];
        })
        .catch(() => this.showErrorMsj('Se produjo un error al recuperar la lista de cajas.'))
    },

    agregarTransferencia(){
      this.$refs.addTransferenciaModal.show();
    },
    transferenciaAgregada(transferencia){
      this.$refs.addTransferenciaModal.hide();
      this.showSpinner();
      this.$store.dispatch('viaticoPago/setTransferencia', transferencia)
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    transferenciaCancelada(){
      this.$refs.addTransferenciaModal.hide();
    },
    borrarTransferencia(item){
      this.showSpinner();
      this.$store.dispatch('viaticoPago/deleteTransferencia', item)
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },

    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar){
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'pesos' || validarTodos) {
        this.pesosValido = null;
        this.pesosInvalidoMsj = this.displayErrorMonto (this.$v.pesos.$error, 
          this.$v.pesos.decimal, this.$v.pesos.minValue); 
        
        if (this.pesosInvalidoMsj.trim() != '') {
          this.pesosValido = false;
        }
      }

      // if (campo == 'observaciones' || validarTodos) {
      //   if (this.$v.observaciones.$error) {
      //     this.observacionesValidas = false;
      //     if (!this.$v.observaciones.maxLength) {
      //       this.observacionesInvalidasMsj = 'Las observaciones sólo pueden contener hasta 5000 caracteres';
      //     }
      //   } else {
      //     this.observacionesValidas = null;
      //     this.observacionesInvalidasMsj = '';
      //   }
      // }
    },
    displayErrorMonto( fieldError, fieldErrorDecimal, fieldErrorMinValue) {
      let errorMsj = '';
      if (fieldError) {
        if (fieldErrorDecimal) {
          errorMsj = 'El monto ingresado debe ser un valor numérico';
        } else if (fieldErrorMinValue) {
          errorMsj = 'El monto ingresado no es válido';
        }
      }
      return errorMsj;
    },
    save() {
      let save = true;

      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      this.$v.$touch();

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        if (save) {
          this.showSpinner();
          this.$store.dispatch('viaticoPago/save')
            .then( () => this.showModalMsj ('El pago se registró con éxito.', this.goBack, this.goBack, 'light'))
            .catch( error => this.showErrorMsj (error))
            .finally(() => this.hideSpinner());
        }
      }
    },
    goBack() {
      if (this.viaticoId != 0) {
        this.$router.push({ name: 'ViaticoData', 
                            params: { id: this.viaticoId }});

      } else {
        this.$router.push({ name: 'Viaticos' }); 
      }
    },
    cajaRegistroActualizada(nombre) {
      this.cajaRegistroNombre = nombre;
      
      let cajaRegistro;
      if (this.cajaRegistroNombre) {
        cajaRegistro = this.getSelected(this.cajasRegistros, this.cajaRegistroNombre);
      }
      this.$store.dispatch('viaticoPago/setCajaRegistro', cajaRegistro);

      if (!this.noValidar) {
        if (this.cajaRegistro) {
          if (this.cajaRegistro.id == 0){
            this.cajaRegistroValida = false;
            this.cajaRegistroInvalidaMsj = 'Debe seleccionar la caja correspondiente.';
          }
        } else {
          this.cajaRegistroValida = false;
          this.cajaRegistroInvalidaMsj = 'Debe seleccionar la caja correspondiente.';
        }
      }
    },
  },
  validations: {
    pesos: { decimal, minValue: minValue(0) },
    // observaciones: {
    //   maxLength: maxLength(5000)
    // },
  },  
}
</script>

<style>
</style>
